/* eslint-disable */
import React from "react";
import { Commodities } from "../../../controls/Commodities";
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";

export const CommoditiesControl: React.FC = () => {
  const [items, setItems] = React.useState<any>([]);
  const [business] = useParameter<any>("@business-units");
  const [value, setValue] = useParameter<string[]>("@commodities_display");
  const [param, setParam] = useParameter<number[]>("@commodities");

  const [defaultSelectedIds, setDefaultSelectedIds] = React.useState<number[]>([]);
  React.useEffect(() => {
    if (param && defaultSelectedIds.length === 0) {
      setDefaultSelectedIds(param);
    }
  }, [defaultSelectedIds, param]);

  const [dictItems] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
    business_unit: Number(business),
    slide: 1,
  });
  React.useEffect(() => {
    if (dictItems) {
      const nextItems = dictItems
        .sort((o1: any, o2: any) => {
          return o1.getValue("order") - o2.getValue("order");
        })
        .map<any>((x) => ({
          id: String(x.id),
          name: (x.getValue("name") as any)[9] as string,
          parent: String(x.getValue("parent")),
          olap_commodity: Number(x.getValue<number>("olap_commodity")),
          disabled: !Boolean(x.getValue<number>("olap_commodity")),
        }));

      setItems(nextItems);

      let selectedItem = nextItems.filter((x) => param && param?.includes(x.olap_commodity));
      if (!selectedItem.length) {
        const defaultSelectedItems = nextItems.filter((x) => defaultSelectedIds.includes(x.olap_commodity));
        selectedItem = (defaultSelectedItems.length ? defaultSelectedItems : nextItems).slice(0, 1);

        if (selectedItem.map((x) => x.olap_commodity)[0] === 201) {
        }
      }

      setParam(selectedItem.map((x) => x.olap_commodity));
      setValue(selectedItem.map((x) => x.id));
    }
  }, [dictItems]);

  const onChange = (values) => {
    const olapValues = items.filter((x) => values?.includes(x.id)).map((x) => x.olap_commodity);
    setParam(olapValues);
    setValue(values);
  };

  const res = React.useMemo(() => {
    return <Commodities items={items} value={value} onChange={onChange} />;
  }, [items, value]);
  if (!items?.length) {
    return <Skeleton variant="rect" width="168px" height="51px" />;
  }
  return res;
};
